module.exports = __webpack_public_path__ + "img/demande-admission.52eb14f.svg";